import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';
import { IDesign, INews } from 'rebus-models';
import { NavController } from '@ionic/angular';
import { AIService } from 'src/app/modules/shared/service/ai.service';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-news-item-search-result',
  templateUrl: './news-item-search-result.component.html',
  styleUrls: ['./news-item-search-result.component.scss']
})
export class NewsItemSearchResultComponent implements OnInit, OnChanges {

  @Input() public design: IDesign;
  @Input() public news: INews;
  @Input() public eventId: string;
  @Input() public userId: string;
  @Output() public evOnClickItem = new EventEmitter<void>();
  public match$: Observable<any>;

  constructor(
    private navCtrl: NavController,
    private aiService: AIService
  ) { }

  public ngOnInit() {
    this.match$ = this.aiService.getRecommendationsForUser(this.userId, 'News', null, this.eventId, this.news.id)
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.news) {
      this.news = changes.news.currentValue;
    }
  }

  public onClickNews() {
    this.navCtrl.navigateForward([`news/detail/${this.news.id}/${this.eventId}`]);
    this.evOnClickItem.emit();
  }
}
